// Tasks
export * from "./AppInfo.component";




// WEBPACK FOOTER //
// ./src/app/modules/userHome/applications/appInfo/index.ts